import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Interceptor funcional (Angular moderno). Adjunta el Bearer token y,
// ante un 401 en rutas no-auth, cierra la sesion y redirige a /login.
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getToken();

  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const isAuthUrl = req.url.includes('/auth/');
      if (err.status === 401 && !isAuthUrl && auth.isAuthenticated()) {
        auth.logout(true);
      }
      return throwError(() => err);
    })
  );
};
